import {gql} from '@apollo/client';

export const PROTEIN_PREDICTION_JOBS_QUERY = gql`
  query ProteinPredictionJobsQuery($proteinVersionId: StrictString!)
  @skipAudit
  @engComponent(name: ANTIBODIES) {
    proteinVersionPredictionJobs(proteinVersionId: $proteinVersionId) {
      id
      status
      modelName
      createdAt
      componentApiIds
      standardizedOutputDownloadUrl
      predictionBatch {
        id
        modelVersion
      }
    }
  }
`;
